import { createSlot } from '@ayocore/platform/client/extensions/createSlot';

/**
 * Точки расширения реестра платежей (SupplierInvoicesList).
 *
 * Позволяют инстансу настроить реестр под свой процесс, не форкая компонент.
 */
export const SupplierInvoiceListExtensions = {
  /**
   * Скрыть кнопку «Создать счёт» в реестре.
   *
   * Нужна инстансам, где счёт заводится только из карточки закупки
   * (technoalliance): свободные счета там — мусор, который некому привязать.
   * Инстансы, где счёт создают в реестре и потом привязывают к сделке
   * (grasias), обработчик не регистрируют и кнопку сохраняют.
   *
   * @example
   * // instances/technoalliance/client/bootstrap.ts
   * SupplierInvoiceListExtensions.hideStandaloneCreate.register(() => true);
   */
  hideStandaloneCreate: createSlot<void, boolean>(),
};
